import React from 'react';
import {
  Column,
  Copy,
  Heading,
  Row,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { RouterButtonLink } from 'src/components/RouterLink/RouterButtonLink';

export interface IParentAdminsHeaderProps {
  corpId: string;
}

export const ParentAdminsHeader: React.FC<IParentAdminsHeaderProps> = ({
  corpId,
}) => {
  const addParentAdminLink = `/corporate/enterprise/parents/${corpId}/admin/create`;

  return (
    <Row gutter={24}>
      <Column phone={9} gutter={24}>
        <Stack y="xxx-sm">
          <Heading variant="h5">Parent admins</Heading>
        </Stack>
        <Copy variant="body" color="secondaryText">
          View and manage this parent account's admins. They'll be able to
          manage this account and any of its child accounts.
        </Copy>
      </Column>
      <Column phone={3} gutter={24} style={{ textAlign: 'center' }}>
        <RouterButtonLink
          href={addParentAdminLink}
          buttonVariant="primary"
          buttonSize="medium"
          useBlockButton
        >
          Add parent admin
        </RouterButtonLink>
      </Column>
    </Row>
  );
};
